import { render, staticRenderFns } from "./ServiceProviderDocuments.vue?vue&type=template&id=dbea29e4&scoped=true&"
import script from "./ServiceProviderDocuments.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderDocuments.vue?vue&type=style&index=0&id=dbea29e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbea29e4",
  null
  
)

export default component.exports